import React, { memo, type JSX } from 'react';
import { ApolloError, useQuery } from '@apollo/client';

import kodplanerQuery from './kodplaner.gql';
import {
  kodplaner as IKodplanerData,
  kodplanerVariables as IKodplanerVariables,
  kodplaner_ekkodplaner,
} from './_QueryTypes/kodplaner';
import { useBaseRouteValue } from '../../../Features/Routing/Utils/routerUtils';
import {
  ILoginStateContext,
  useLoginStateContext,
} from '../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';

interface IKodplanManagerQueryBag {
  kodplaner: kodplaner_ekkodplaner[] | null;
  loading: boolean;
  error?: ApolloError;
}

interface IProps {
  children: (kodplanManagerQueryBag: IKodplanManagerQueryBag) => JSX.Element;
}
const KodplanManagerQuery: React.FunctionComponent<IProps> = props => {
  const { database } = useBaseRouteValue();
  const loginState = useLoginStateContext();
  return (
    <InnerKodplanManagerQuery
      database={database}
      loginState={loginState}
      {...props}
    />
  );
};

interface IInnerProps extends IProps {
  database?: string | undefined;
  loginState: ILoginStateContext;
}
const InnerKodplanManagerQuery: React.FunctionComponent<IInnerProps> = memo(
  props => {
    const { children } = props;

    const { loading, error, data } = useQuery<
      IKodplanerData,
      IKodplanerVariables
    >(kodplanerQuery, {
      variables: { dbname: props.database ?? '' },
      skip: !props.database || !props.loginState.isLoggedIn,
    });
    const kodplanerList =
      data != null && data.ekkodplaner != null ? data.ekkodplaner : null;

    return children({
      kodplaner: kodplanerList,
      loading: loading || !props.database,
      error: error,
    });
  }
);
InnerKodplanManagerQuery.displayName = 'InnerKodplanManagerQuery';

export default KodplanManagerQuery;
